//#region [IMPORT]

// === THIRD-PARTY ===
import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { Navigate, useNavigate } from 'react-router-dom';

// ### MUI / STYLES ###
import { useTheme } from '@mui/material/styles';
import {
  Box,
} from '@mui/material';

// === COMPONENTS ===
import { FileList } from './FileList/FileList';
import { FileView } from './FileView/FileView';
import { TaskView } from './TaskView/TaskView';
import { RuleList } from './RuleList/RuleList';
import { RuleView } from './RuleView/RuleView';
import { ExpressionProvider } from './RuleView/components/ExpressionContext/ExpressionContext.jsx';
import {  AnalyticsProvider } from './AnalyticsContext/AnalyticsContext';

// === HOOKS ===
import { useSession } from 'pages/PageManager/components/SessionContext';

//#endregion

//-----------------------------------------------------------------
export function DocAnalytics() {
  //-----------------------------------------------------------------

  //#region [VALUES]
  
  const { user_details } = useSession();

  const theme        = useTheme();
  const navigate     = useNavigate();

  const path_rule_list = '/rules';
  const path_rule_view = '/rules/:rule_id';
  const path_file_list = '/files';
  const path_file_view = '/files/:file_id/*';
  const path_task_view = '/files/:file_id/task';
  const path_misc      = '/*';
 
  const hasPermission = user_details.roles?.some((item) => item.RoleName === 'analyst');

  let page = localStorage.getItem('display_page');
  if( !page ) page = 'verify';

  //#endregion

  //#region [STYLES]

  const _styles = {
    container: {
      height: `100%`,
      overflow  : 'hidden',
      'z-index' : '0',
      backgroundColor : theme.palette.background.secondary[theme.palette.mode],
    },
  }

  //#endregion

  //#region [green] Events

  if( user_details.roles.length === 0 ) {
    return null;
  }

  if( !hasPermission ) {
    navigate( '/' + page );    
  }

  //#endregion

  //#region [Main] render information
  //-----------------------------------------------------------------
  function display() {
    //-----------------------------------------------------------------
    return (
      <Box sx={_styles.container}>
        <Routes>
          <Route path={ path_rule_list } element={ <RuleList />  } />
          <Route path={ path_rule_view } element={ 
            <ExpressionProvider><RuleView /></ExpressionProvider>
          } />
          <Route path={ path_file_view } element={ <AnalyticsProvider /> }>
            <Route index element={<FileView />} />
            <Route path='task' element={<TaskView />} />
          </Route>
          <Route path={ path_file_list } element={ <FileList />  } />
          <Route path={ path_misc      } element={ <Navigate to='files' replace /> } />
        </Routes>
      </Box>
    )
  }

  //#endregion

  return display();
}
